import { Component, OnInit, EventEmitter, ViewChild,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { stateOptionsSample, orgStudyCenterOptionsConstant, siteEvalOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DateObject, Document_Upload, Document_Upload_File, IST_SITE_EVALUATION } from '../../../../models/common';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {  SiteEvaluation } from 'src/app/models/um/organization';


@Component({
  selector: 'app-ist-site-evaluation-view-modal',
  templateUrl: './ist-site-evaluation-view-modal.component.html',
  styleUrls: ['./ist-site-evaluation-view-modal.component.scss']
})
export class IstSiteEvaluationViewModalComponent implements OnInit {

  uploadedFiles = [];
  @Input() public Content: any;
  itemId;
  formFields;
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  FilesList;
  siteEvaluationType = [];
  organisationStudyCenter = [];
  assignedRepresentativeOptions = [];
  contactPersonOptions = [];
  VisitedFiles = [];
  UploadedFilesList = [];
  UploadedFilesListCopy = [];
  userType: string = "";
  minDate = new Date()
  siteevaluation:SiteEvaluation;
  siteEvaluationForm: UntypedFormGroup;
  content: any;
  ExpdateofVisit :Date;
  AssignDate:Date;
  heading: string;
  action: Subject<any> = new Subject();
  ApplicationID: any;
  document_attach_list: Document_Upload_File[] = [];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  myDate1 = new Date();
  myDate = new Date(this.myDate1.setDate(new Date().getDate() - 1))
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService,
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-013');
    this.files = [];
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.userType = this.userService.getUserType();
    this.getMasterData();

    this.siteEvaluationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      STUDY_CENTER_ID: new UntypedFormControl(""),
      EVALUATION_TYPE_ID: new UntypedFormControl(""),
      REPRESENTATIVE_ID: new UntypedFormControl(""),
      CONTACT_PERSON_ID: new UntypedFormControl(""),
      CONTACT_PERSON_DESIGNATION: new UntypedFormControl(""),
      EXPECTED_VISIT_DATE: new UntypedFormControl(null),
      ASSIGN_DATE: new UntypedFormControl(null),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0),
      EXPECTED_VISIT_DATEO : new UntypedFormControl(null),
      ASSIGN_DATEO : new UntypedFormControl(null),
    });

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();
    this.siteevaluation = new SiteEvaluation();
    } else if (this.Content.heading === 'View') { //View mode 
      this.getRecordFprEdit();
      this.siteEvaluationForm.disable();
    }
    
    this.ExpdateofVisit = new Date();
    this.AssignDate = new Date();
  }

  getMasterData() {
    this.summaryService.getScreenDataForEdit("api/ISTSiteevaluation/DropDownMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(result => {
      this.siteEvaluationType = result["MasterData1"];
      this.siteEvaluationType = [{ label: "Select", value: "", checked: true }].concat(this.siteEvaluationType);
      this.organisationStudyCenter = result["MasterData2"];
      this.organisationStudyCenter = [{ label: "Select", value: "", checked: true }].concat(this.organisationStudyCenter);
      this.assignedRepresentativeOptions = result["MasterData3"];
      this.assignedRepresentativeOptions = [{ label: "Select", value: "", checked: true }].concat(this.assignedRepresentativeOptions);
      this.contactPersonOptions = result["MasterData4"];
      this.contactPersonOptions = [{ label: "Select", value: "", checked: true }].concat(this.contactPersonOptions);
    });
  }

  showFiles() {
    let files = '';
    this.uploadedFiles = [];

    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }

    }

    for (let i = 0; i < this.files.length; i++) {
      let newAttachment = this.files[i].name;
      this.uploadedFiles.push(newAttachment);
    }

    return files;
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTSiteevaluation/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      this.siteEvaluationForm.patchValue({
        ID: result["Modal"]["ID"],
        APPLICATION_ID: result["Modal"]["APPLICATION_ID"],
        STUDY_CENTER_ID: result["Modal"]["STUDY_CENTER_ID"],
        EVALUATION_TYPE_ID: result["Modal"]["EVALUATION_TYPE_ID"],
        REPRESENTATIVE_ID: result["Modal"]["REPRESENTATIVE_ID"],
        CONTACT_PERSON_ID: result["Modal"]["CONTACT_PERSON_ID"],
        CONTACT_PERSON_DESIGNATION: result["Modal"]["CONTACT_PERSON_DESIGNATION"],
        EXPECTED_VISIT_DATE: result["Modal"]["EXPECTED_VISIT_DATE"],
        ASSIGN_DATE: result["Modal"]["ASSIGN_DATE"],
        NOTES: result["Modal"]["NOTES"],
        STATUS: result["Modal"]["STATUS"],
      });

      this.siteEvaluationForm.controls["STUDY_CENTER_ID"].disable();
      this.siteEvaluationForm.controls["EVALUATION_TYPE_ID"].disable();
      this.VisitedFiles = result["StatusFilesList"];
      this.UploadedFilesList = result["FilesList"];
      this.UploadedFilesListCopy = _.cloneDeep(this.UploadedFilesList);
      if (result["Modal"]["EXPECTED_VISIT_DATE"] != null && result["Modal"]["EXPECTED_VISIT_DATE"] != undefined) {
        // var formd = this.datepipe.transform(result["Modal"]["EXPECTED_VISIT_DATE"], 'dd-MMM-yyyy');

        // this.ExpdateofVisit = new Date(this.siteEvaluationForm.controls["EXPECTED_VISIT_DATE"].value);
        
        this.ExpdateofVisit = this.commonService.getdisplayedDate(this.siteEvaluationForm.controls["EXPECTED_VISIT_DATE"].value);
        this.siteEvaluationForm.controls["EXPECTED_VISIT_DATE"].setValue(this.ExpdateofVisit);
      }
      if (result["Modal"]["ASSIGN_DATE"] != null && result["Modal"]["ASSIGN_DATE"] != undefined) {
        this.AssignDate = this.commonService.getdisplayedDate(this.siteEvaluationForm.controls["ASSIGN_DATE"].value);
        this.siteEvaluationForm.controls["ASSIGN_DATE"].setValue(this.AssignDate);
      }

      this.extendedForm.rowid = result["Modal"]["ID"];
      this.extendedForm.getResponse();
    });

  }
private getForm():SiteEvaluation
{
  const formModel = this.siteEvaluationForm.getRawValue();
  let obj = new SiteEvaluation();
  obj = {
    ID: formModel.ID,
    APPLICATION_ID: formModel.APPLICATION_ID || '',
    STUDY_CENTER_ID : formModel.STUDY_CENTER_ID || '',
    EVALUATION_TYPE_ID : formModel.EVALUATION_TYPE_ID || '',
    REPRESENTATIVE_ID :formModel.REPRESENTATIVE_ID || '',
    CONTACT_PERSON_ID : formModel.CONTACT_PERSON_ID || '',
    CONTACT_PERSON_DESIGNATION : formModel.CONTACT_PERSON_DESIGNATION || '',
    EXPECTED_VISIT_DATE: formModel.EXPECTED_VISIT_DATE || null,
    ASSIGN_DATE: formModel.ASSIGN_DATE || null,
    EXPECTED_VISIT_DATEO : formModel.EXPECTED_VISIT_DATEO || null,
    ASSIGN_DATEO : formModel.ASSIGN_DATEO || null,
    NOTES: formModel.NOTES || "",
    STATUS: formModel.STATUS || 0,
  };
  if(this.Content.heading !='Add')
  {
    this.siteevaluation.ID = obj.ID;
    this.siteevaluation.APPLICATION_ID =formModel.APPLICATION_ID;
    this.siteevaluation.STUDY_CENTER_ID = formModel.STUDY_CENTER_ID ;
    this.siteevaluation.EVALUATION_TYPE_ID = formModel.EVALUATION_TYPE_ID;
    this.siteevaluation.REPRESENTATIVE_ID = formModel.REPRESENTATIVE_ID;
    this.siteevaluation.CONTACT_PERSON_ID = formModel.CONTACT_PERSON_ID;
    this.siteevaluation.CONTACT_PERSON_DESIGNATION = formModel.CONTACT_PERSON_DESIGNATION;
    this.siteevaluation.EXPECTED_VISIT_DATE = formModel.EXPECTED_VISIT_DATE;
    this.siteevaluation.ASSIGN_DATE = formModel.ASSIGN_DATE;
    const exdate =  this.GetExpdateofVisit();
    this.siteevaluation.EXPECTED_VISIT_DATEO = exdate;
    this.siteevaluation.ASSIGN_DATEO = formModel.ASSIGN_DATEO;
    this.siteevaluation.NOTES = formModel.NOTES;
    this.siteevaluation.STATUS = formModel.STATUS;
   return this.siteevaluation;
  }
  else{
    const exdate =  this.GetExpdateofVisit();
    obj.EXPECTED_VISIT_DATEO = exdate;
    return obj 
  }


}
  SaveSiteEvalution() {
    if (this.validateControls()) {
     // var formData = this.siteEvaluationForm.value;
     var formData = this.getForm();

      var formData1 = new FormData();
      formData["APPLICATION_ID"] = this.ApplicationID;
      if (formData["EXPECTED_VISIT_DATE"] != null && formData["EXPECTED_VISIT_DATE"] != undefined) {
        formData["EXPECTED_VISIT_DATE"] = new Date(formData["EXPECTED_VISIT_DATE"]);
        const ldate = new Date(formData["EXPECTED_VISIT_DATE"]);
        formData["STR_EXPECTED_VISIT_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      }
      if (formData["STATUS"] != null && formData["STATUS"] != undefined) {
        formData["STATUS"] = (formData["STATUS"]);
      }

      // if(this.document_attach_list != null && this.document_attach_list.length > 0){
      //   for (let i = 0; i < this.document_attach_list.length; i++) {
      //     let fileEx = this.UploadedFilesListCopy.find(x=> x.FileName == this.document_attach_list[i].DOCUMENT_NAME);
      //     if(fileEx !=null){
      //       let index = this.document_attach_list.findIndex(x=> x.DOCUMENT_NAME == fileEx.FileName);
      //       this.document_attach_list.splice(index, 1);
      //       this.UploadedFilesList.push(fileEx);
      //       i--;
      //     } 
      //   }
      // }

      formData["Files"] = this.UploadedFilesList;

      if (this.document_attach_list != null && this.document_attach_list.length > 0) {       
        for (let i = 0; i < this.document_attach_list.length; i++) {        
            this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
            formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }

      formData1.append("ScreenData", JSON.stringify(formData));

      if (this.Content.heading == "Add") {
        this.summaryService.FilesInsert("api/ISTSiteevaluation/Insert", formData1).subscribe(result => {
          if (result.Status == 0) {
            this.siteEvaluationForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0)
              {
                this.commonService.SuccessBanner('Site evaluation added successfully');
                this.modalRef.close();
              }
              else
              {
                this.commonService.ValidationBanner(result1.Message);
              }

            });
          } else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.FilesInsert("api/ISTSiteevaluation/Update", formData1).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES") {
            this.siteEvaluationForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") 
              {
                if (result.Status == 0)
                {
                  this.commonService.SuccessBanner('Site Evaluation details updated successfully');
                  this.modalRef.close();
                }
                else
                {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else 
              {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES")
                {
                  this.commonService.ValidationBanner(result.Message);
                }
                else
                {
                  this.commonService.SuccessBanner('Site Evaluation details updated successfully');
                  this.modalRef.close(formData);
                }
              }
            });
          } 
          else 
          {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
    }
  }
  EXPvistdate_DateModified: boolean = false;
  FullExp_Date: DateObject;
  Expdateselect(event)
  {
    this.EXPvistdate_DateModified = true;
    this.FullExp_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23, 
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.EXPvistdate_DateModified,
    }
  }
  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  GetExpdateofVisit(){
    const formModel = this.siteEvaluationForm.getRawValue();
    const date = new Date(formModel.EXPECTED_VISIT_DATE);
     if (this.ComparingDates(this.ExpdateofVisit, date) || this.FullExp_Date == null || this.FullExp_Date == undefined) {
       this.FullExp_Date = {
         Day: date.getDate(),
         Month: (date.getMonth() + 1),
         Year: date.getFullYear(),
         Hours: 23,
         Minutes: 59,
         Seconds: 59,
         IsEndDate: true,
         HasValue: true,
         IsDateModified: false
       }
     }
     return this.FullExp_Date;
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.siteEvaluationForm.value;

    if(this.staticformFields?.STUDY_CENTER_ID.IS_MANDATORY && this.staticformFields?.STUDY_CENTER_ID.IS_Display){
      if (formData.STUDY_CENTER_ID === null || formData.STUDY_CENTER_ID === "") {
        $("#STUDY_CENTER_ID").addClass("ng-touched ng-invalid validate-error");
        $("#STUDY_CENTER_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.STUDY_CENTER_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#STUDY_CENTER_ID").addClass("ng-untouched ng-valid");
        $("#STUDY_CENTER_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.EVALUATION_TYPE_ID.IS_MANDATORY && this.staticformFields?.EVALUATION_TYPE_ID.IS_Display){
      if (formData.EVALUATION_TYPE_ID === null || formData.EVALUATION_TYPE_ID === "") {
        $("#EVALUATION_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#EVALUATION_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.EVALUATION_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#EVALUATION_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#EVALUATION_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.REPRESENTATIVE_ID.IS_MANDATORY && this.staticformFields?.REPRESENTATIVE_ID.IS_Display){
      if (formData.REPRESENTATIVE_ID === null || formData.REPRESENTATIVE_ID === "") {
        $("#REPRESENTATIVE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#REPRESENTATIVE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.REPRESENTATIVE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REPRESENTATIVE_ID").addClass("ng-untouched ng-valid");
        $("#REPRESENTATIVE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.CONTACT_PERSON_ID.IS_MANDATORY && this.staticformFields?.CONTACT_PERSON_ID.IS_Display){
      if (formData.CONTACT_PERSON_ID === null || formData.CONTACT_PERSON_ID === "") {
        $("#CONTACT_PERSON_ID").addClass("ng-touched ng-invalid validate-error");
        $("#CONTACT_PERSON_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.CONTACT_PERSON_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#CONTACT_PERSON_ID").addClass("ng-untouched ng-valid");
        $("#CONTACT_PERSON_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.CONTACT_PERSON_DESIGNATION.IS_MANDATORY && this.staticformFields?.CONTACT_PERSON_DESIGNATION.IS_Display){
      if (formData.CONTACT_PERSON_DESIGNATION === null || formData.CONTACT_PERSON_DESIGNATION === "") {
        $("#CONTACT_PERSON_DESIGNATION").addClass("ng-touched ng-invalid validate-error");
        $("#CONTACT_PERSON_DESIGNATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.CONTACT_PERSON_DESIGNATION.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#CONTACT_PERSON_DESIGNATION").addClass("ng-untouched ng-valid");
        $("#CONTACT_PERSON_DESIGNATION").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.EXPECTED_VISIT_DATE.IS_MANDATORY && this.staticformFields?.EXPECTED_VISIT_DATE.IS_Display){
      if (formData.EXPECTED_VISIT_DATE === null || formData.EXPECTED_VISIT_DATE === "") {
        $("#EXPECTED_VISIT_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#EXPECTED_VISIT_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.EXPECTED_VISIT_DATE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#EXPECTED_VISIT_DATE").addClass("ng-untouched ng-valid");
        $("#EXPECTED_VISIT_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.NOTES.IS_MANDATORY && this.staticformFields?.NOTES.IS_Display){
      if (formData.NOTES === null || formData.NOTES === "") {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.SiteEval_CF.IS_MANDATORY && this.staticformFields?.SiteEval_CF.IS_Display){
      if (this.document_attach_list == null || this.document_attach_list.length == 0) {
        isValid = false;
        message += `Please upload ${this.staticformFields?.SiteEval_CF.LABEL_NAME} <br/>`;
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      message = message + this.extendedForm.validateControlsMsgs();
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: message } } });
    return isValid;
  }

  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      // this.documaent_attach_list = this.documaent_attach_list.filter(function (sec) {
      //   return sec.ID != code;
      // }, code);
      let index = this.document_attach_list.findIndex(x => x.ID == file.ID);
      this.document_attach_list.splice(index, 1);
    }
    else {
      file.Status = "Delete";
      let index = this.document_attach_list.findIndex(x => x.ID == file.ID);
      this.document_attach_list.splice(index, 1);
    }
  }

  DeleteSavedUpload(item): void {
    // this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
    //   let code = item;
    //   let index = this.FilesList.findIndex(x => x.ID == code);
    //   this.FilesList.splice(index, 1);
    //   // this.FilesList = this.FilesList.filter(function (sec) {
    //   //     return sec.ID != code;
    //   //   }, code);
    // });
    let code = item;
    let index = this.UploadedFilesList.findIndex(x => x.ID == code);
    this.UploadedFilesList.splice(index, 1);
  }

 /*  uploadchange(event): void {
    if (this.documaent_attach_list == undefined || this.documaent_attach_list == null) {
      this.documaent_attach_list = [];
    }
    var file = event.target.files[0].name;
    var ext = file.match(/\.([^\.]+)$/)[1];
    var filesize = event.target.files[0].size;
    if (file != null && ((filesize > (1024 * 1024 * 10)) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
    else {
      for (let i = 0; i < event.target.files.length; i++) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = this.documaent_attach_list.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if (hasValue.length > 0) {
          this.commonService.ValidationBanner('File already exists with ' + uploadFile.DOCUMENT_NAME + ' Please update the unique file name');

          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'File already exists with ' + uploadFile.DOCUMENT_NAME + ' Please update the unique file name' } } });
        } else {
          this.documaent_attach_list.push(uploadFile);
        }
      }
    }
  } */

  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];
    
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;   
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) 
      {
        hasUnFormat = true;
      }
      else 
      {
        let hasValue;
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        if(this.UploadedFilesList && this.UploadedFilesList.length > 0 ){
          hasValue = this.UploadedFilesList.filter(x=> x.FileName.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        } else{
          hasValue = this.document_attach_list.filter(x=> x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if(hasValue.length > 0)
        {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } else
        {
          if (this.staticformFields.SiteEval_CF.IS_MULTISELECT){
              this.document_attach_list.push(uploadFile);
            } else {
              this.document_attach_list =[];
              this.UploadedFilesList = [];
              this.document_attach_list.push(uploadFile);
            }
        }
      }
    }

    if(hasUnFormat){
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB"); 
    }

    if(hasMultipleFiles){
      this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
    }
  }
  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removedz
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    // this.showFiles();
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
